'use client';
var classes = {"root":"m_cbb4ea7e","steps":"m_aaf89d0b","separator":"m_2a371ac9","content":"m_78da155d","step":"m_cbb57068","step--horizontal":"m_f56b1e2c","step--vertical":"m_833edb7e","verticalSeparator":"m_6496b3f3","stepWrapper":"m_818e70b","stepIcon":"m_1959ad01","stepCompletedIcon":"m_a79331dc","stepBody":"m_1956aa2a","stepLabel":"m_12051f6c","stepDescription":"m_164eea74"};

export { classes as default };
//# sourceMappingURL=Stepper.module.css.mjs.map
